// The Journal: blogs/news/index.html (all stories) and blogs/news/<slug>.html (one story)
(function () {
  const e = LC.escape;
  const main = document.getElementById('journal-main');
  const articles = LC.journal();
  const slug = LC.param('a');
  const article = slug && articles.find((a) => a.slug === slug);

  if (article) renderArticle(article);
  else renderIndex();

  function renderIndex() {
    const path = LC.journalUrl;
    const categories = ['All', ...new Set(articles.map((a) => a.category))];
    const [lead, ...rest] = articles;

    main.innerHTML = `
      <section class="journal-hero">
        <div class="container">
          <nav class="breadcrumb" aria-label="Breadcrumb"><ol><li><a href="index.html">Home</a></li><li aria-current="page">The Journal</li></ol></nav>
          <p class="chip">Le Chic Beauty Journal</p>
          <h1>Hair Care Tips &amp; <em>Styling Guides</em></h1>
          <p class="journal-intro">Expert advice from Le Chic Beauty on halo hair extensions, caviar hair masks, blowouts and styling, to help you care for and style every hair type.</p>
        </div>
      </section>

      <section class="section journal-index" aria-label="Journal stories">
        <div class="container">
          <a class="journal-lead" href="${LC.articleUrl(lead.slug)}">
            <div class="journal-lead-media"><img src="${e(lead.cover)}" alt="${e(lead.coverAlt)}"></div>
            <div class="journal-lead-copy">
              <p class="story-meta"><span>${e(lead.category)}</span><time datetime="${lead.date}">${LC.formatDate(lead.date)}</time><span>${lead.minutes} min read</span></p>
              <h2>${e(lead.title)}</h2>
              <p>${e(lead.excerpt)}</p>
              <span class="link-arrow">Read the story <span aria-hidden="true">→</span></span>
            </div>
          </a>

          <div class="journal-filter" role="group" aria-label="Filter stories by topic">
            ${categories.map((c, i) => `<button type="button" class="tab${i === 0 ? ' is-active' : ''}" data-cat="${e(c)}" aria-pressed="${i === 0}">${e(c)}</button>`).join('')}
          </div>

          <div class="story-grid" id="story-grid">${rest.map(LC.storyCardHTML).join('')}</div>
        </div>
      </section>`;

    const title = 'Hair Care Tips, Styling Guides & Extension Advice | Le Chic Beauty Journal';
    const description = 'Read the Le Chic Beauty Journal for hair care tips, blowout and styling guides, caviar hair mask advice and expert tips on choosing, wearing and caring for halo extensions.';
    LC.seo({
      title,
      description,
      path,
      image: lead.cover,
      jsonld: [
        LC.webPageLd('CollectionPage', path, title, description, { breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` } }),
        Object.assign(LC.breadcrumbLd([['Home', 'index.html'], ['The Journal', path]]), { '@id': `${LC.abs(path)}#breadcrumb` }),
        {
          '@type': 'Blog',
          '@id': `${LC.abs(path)}#blog`,
          name: 'Le Chic Beauty Journal',
          url: LC.abs(path),
          publisher: { '@id': `${LC.SITE}#organization` },
          blogPost: articles.map((a) => ({ '@type': 'BlogPosting', headline: a.title, url: LC.abs(LC.articleUrl(a.slug)), datePublished: a.date, image: LC.abs(a.cover) }))
        }
      ]
    });

    const grid = document.getElementById('story-grid');
    main.querySelectorAll('.journal-filter .tab').forEach((btn) => {
      btn.addEventListener('click', () => {
        const cat = btn.dataset.cat;
        main.querySelectorAll('.journal-filter .tab').forEach((b) => {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', String(b === btn));
        });
        const listed = cat === 'All' ? rest : articles.filter((a) => a.category === cat);
        grid.innerHTML = listed.map(LC.storyCardHTML).join('');
      });
    });
  }

  function renderArticle(a) {
    const path = LC.articleUrl(a.slug);
    const products = (a.products || []).map(LC.findProduct).filter(Boolean);
    const more = articles.filter((x) => x.slug !== a.slug)
      .sort((x, y) => (y.category === a.category) - (x.category === a.category))
      .slice(0, 3);

    // Give every section heading an anchor and build a table of contents
    const toc = [];
    const slugify = (s) => s.toLowerCase().replace(/<[^>]+>/g, '').replace(/&[a-z]+;/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const body = a.body.replace(/<h2>([\s\S]*?)<\/h2>/g, (m, inner) => {
      const text = inner.replace(/<[^>]+>/g, '').trim();
      let id = slugify(text) || `section-${toc.length + 1}`;
      if (toc.some((t) => t.id === id)) id += `-${toc.length + 1}`;
      toc.push({ id, text });
      return `<h2 id="${id}">${inner}</h2>`;
    });

    main.innerHTML = `
      <article itemscope itemtype="https://schema.org/BlogPosting">
        <header class="article-hero">
          <div class="container article-head">
            <nav class="breadcrumb" aria-label="Breadcrumb">
              <ol><li><a href="index.html">Home</a></li><li><a href="${LC.journalUrl}">The Journal</a></li><li aria-current="page">${e(a.title)}</li></ol>
            </nav>
            <p class="chip">${e(a.category)}</p>
            <h1 itemprop="headline">${e(a.title)}</h1>
            <p class="story-meta"><span>By Le Chic Beauty</span><time datetime="${a.date}" itemprop="datePublished">${LC.formatDate(a.date)}</time><span>${a.minutes} min read</span></p>
          </div>
          <div class="container">
            <div class="article-cover"><img src="${e(a.cover)}" alt="${e(a.coverAlt)}" itemprop="image"></div>
          </div>
        </header>

        <div class="container article-layout">
          <div class="article-main">
            ${toc.length > 2 ? `
              <nav class="article-toc" aria-label="In this article">
                <p class="toc-title">In this article</p>
                <ol>${toc.map((t) => `<li><a href="${path}#${t.id}">${e(t.text)}</a></li>`).join('')}</ol>
              </nav>` : ''}
            <div class="article-body" itemprop="articleBody">${body}</div>
          </div>
          ${products.length ? `
            <aside class="article-shop" aria-label="Shop the story">
              <p class="chip chip-greige">Shop the Story</p>
              <ul>
                ${products.map((p) => {
                  const img = LC.productImage(p);
                  return `<li><a href="${LC.productUrl(p.id)}">
                    <img src="${e(img.src)}" alt="${e(img.alt)}" loading="lazy">
                    <span><strong>${e(p.name)}</strong><em>${p.price != null ? LC.formatPrice(p.price) : 'Price coming soon'}</em></span>
                  </a></li>`;
                }).join('')}
              </ul>
            </aside>` : ''}
        </div>
      </article>

      <section class="section section-mist" aria-labelledby="more-title">
        <div class="container">
          <div class="section-head">
            <div>
              <p class="chip">Keep Reading</p>
              <h2 id="more-title">More Hair Care &amp; Styling Tips</h2>
            </div>
            <a class="link-arrow" href="${LC.journalUrl}">All Journal stories <span aria-hidden="true">→</span></a>
          </div>
          <div class="story-grid">${more.map(LC.storyCardHTML).join('')}</div>
        </div>
      </section>`;

    const title = `${a.title} | Le Chic Beauty Journal`;
    LC.seo({
      title,
      description: a.excerpt,
      path,
      image: a.cover,
      imageAlt: a.coverAlt,
      type: 'article',
      jsonld: [
        LC.webPageLd('WebPage', path, title, a.excerpt, { breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` } }),
        Object.assign(LC.breadcrumbLd([['Home', 'index.html'], ['The Journal', LC.journalUrl], [a.title, path]]), { '@id': `${LC.abs(path)}#breadcrumb` }),
        LC.articleLd(a, path),
        products.length ? LC.itemListLd(products, path, `Products in “${a.title}”`) : null
      ]
    });
    const articleMeta = document.head.querySelector('meta[property="article:published_time"]') || document.createElement('meta');
    articleMeta.setAttribute('property', 'article:published_time');
    articleMeta.setAttribute('content', a.date);
    document.head.appendChild(articleMeta);
  }
})();
